export const PORT_MAX_VALUE = 65535;

// eslint-disable-next-line import/prefer-default-export
export function validatePortNumberRange(portNumberRange: number, startPortNumber: number): boolean {
  if (Number.isNaN(portNumberRange)) {
    return false;
  }

  if (portNumberRange < 1) {
    return false;
  }

  if (portNumberRange > PORT_MAX_VALUE) {
    return false;
  }

  if (Number.isNaN(startPortNumber)) {
    return true;
  }

  if (portNumberRange > PORT_MAX_VALUE + 1 - startPortNumber) {
    return false;
  }

  return true;
}
